const email = {
  sendEmail: "Send Email",
  sendBtn: "Send",
  sent: "Email sent!",
  to: "To",
  from: "From",
  subject: "Subject",
  template: "Template",
  noTemplate: "— No template —",
  variables: "Variables",
  sendFrom: "Send from",
  cancel: "Cancel",
  showCcBcc: "CC/BCC",
  hideCcBcc: "Hide CC/BCC",
  toPlaceholder: "email@example.com (comma-separated)",
  recipientRequired: "Recipient required",
  subjectRequired: "Subject required",
  status: "Status",
  sentAt: "Sent",
  opens: "Opens",
  clicks: "Clicks",
  firstOpened: "First open",
  clickedLinks: "Clicked Links",
  htmlPreview: "HTML Preview",
  bounceReason: "Bounce reason",
  errorMessage: "Error",
  totalSent: "Sent",
  opened: "Opened",
  clicked: "Clicked",
  bounced: "Bounced",
  openRate: "Open Rate",
  clickRate: "Click Rate",
  noEmailsSent: "No emails sent yet",
  emails: "Emails",
} as const;
export default email;
